import { BsHouse, BsPersonCircle } from "react-icons/bs";
import { TbSunset } from "react-icons/tb";

import {
  CardRow,
  CardRowActions,
  CardRowCell,
  CardRowCells,
  CardRowDivider,
} from "@/components/CardRow";
import Pill from "@/components/Pill";
import PowerPlantNameDisplay from "@/components/PowerPlantNameDisplay";
import { OverdueStatus } from "@/utils/statusFormater";

import { PersonProps } from "./types";

const PersonCard = ({
  name,
  nickname,
  situation,
  consortia,
  facilitiesCount,
  active = true,
  actions,
}: PersonProps) => {
  const overdueInformation = OverdueStatus(situation);

  return (
    <CardRow>
      <CardRowCells
        divider={false}
        className="grid w-3/5 min-w-[700px] max-w-[820px] shrink-0 grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(72px,100px)] items-center justify-items-start gap-2"
      >
        <CardRowCell
          className="w-full min-w-0 max-w-full"
          label={nickname ? "APELIDO" : "NOME"}
          value={nickname || name}
          icon={<BsPersonCircle />}
          valueProps={{
            variant: "pSmall",
            className: "block w-full truncate",
            title: nickname ? `${nickname} (${name})` : name,
          }}
          rightContent={
            !active && (
              <div className="shrink-0">
                <Pill variant="red" text="Inativo" />
              </div>
            )
          }
        />
        <CardRowCell
          className="w-full min-w-0 max-w-full"
          label="SPEs"
          value=""
          icon={<TbSunset />}
          valueProps={{ variant: "pSmall", className: "block w-full overflow-hidden" }}
          renderValue={() =>
            consortia && consortia.length > 0 ? (
              <PowerPlantNameDisplay name={consortia} className="max-w-full overflow-hidden" />
            ) : (
              <span>-</span>
            )
          }
        />
        <CardRowCell
          className="w-full min-w-0 max-w-full"
          label="UCs"
          value={facilitiesCount ?? 0}
          icon={<BsHouse />}
          valueProps={{ variant: "pSmall", className: "whitespace-nowrap" }}
        />
      </CardRowCells>
      <CardRowActions className="gap-10 pl-8">
        <CardRowCell
          className="min-w-[200px]"
          label="SITUAÇÃO"
          value={overdueInformation.label}
          status={{
            label: overdueInformation.label,
            tone: overdueInformation.backgroundColor === "green" ? "success" : "danger",
          }}
        />
        <CardRowDivider />
        {actions}
      </CardRowActions>
    </CardRow>
  );
};

export default PersonCard;
